import { SongTabFormWrapper } from 'app/components/Song/SongTabFormWrapper';
import { Skeleton } from '@chakra-ui/react';
import { SongDetailsFormGrid } from 'app/components/Song/Details/SongDetailsFormGrid';

export const SongDetailsFormLoader = () => {
  const sx = { h: '48px', mb: '22px' };
  return (
    <SongTabFormWrapper>
      <SongDetailsFormGrid
        altTitle={<Skeleton {...sx} />}
        notes={<Skeleton height="100%" />}
        artist={<Skeleton {...sx} />}
        genres={<Skeleton {...sx} />}
        keySignature={<Skeleton {...sx} />}
        timeSignature={<Skeleton {...sx} />}
        tempo={<Skeleton {...sx} />}
        language={<Skeleton {...sx} />}
        explicit={<Skeleton {...sx} />}
        duration={<Skeleton {...sx} />}
        creationDate={<Skeleton {...sx} />}
        location={<Skeleton {...sx} />}
      />
    </SongTabFormWrapper>
  );
};
